// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-popup-container {
  opacity: 0;
  transition: top 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.footer-popup-container.is-open {
  top: 0%;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/footer-popup/footer-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,0DACE;AAAJ;AAGE;EACE,OAAA;EACA,UAAA;AADJ","sourcesContent":[".footer-popup-container {\r\n  opacity: 0;\r\n  transition:\r\n    top 0.3s ease-in-out,\r\n    opacity 0.3s ease-in-out;\r\n\r\n  &.is-open {\r\n    top: 0%;\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
